import { atom } from 'nanostores';

export const $hasUndo = atom(false);
export const $hasRedo = atom(false);
